import React, { useEffect, useState } from 'react'
import LeadError from '../LeadError'
import Radio from 'app/theme/forms/Radio'
import { Spinner } from 'app/theme/Spinner'

export default function LeadCateringWedding(props) {
  const { occasions, occasionsIsLoading, setData } = props

  const occasionsPersonalAndWedding = occasions.filter(({code}) => code.match(/personal|wedding/)?.length > 0)

  // NOTE
  // Personal is selected by default because occasion.code = 'personal'.
  // This keeps the personal steps shown until the user selects 'No'.
  // If occasion is set to undefined/null, the form will be unable
  // to visit the previous step, until the user makes a selection.

  return (
    <div>
      <div className="font-light">
        {occasionsIsLoading ? (
          <div className="">
            <Spinner className="text-blue w-10 h-10 mx-auto my-5"/>
          </div>
        ) : occasions.length ? (
            <WeddingQuestion {...props} setData={setData} occasions={occasionsPersonalAndWedding} />
        ) : (
          <div className="font-bold px-8 py-3 text-center text-red-600">
            An unexpected error occurred. Please try to submit your details again in a few minutes.
          </div>
        )}
      </div>
    </div>
  )
}

function WeddingQuestion({setData, occasions, ...props}) {
  const { errors, posthog, reloadExperiments } = props
  const [selected, setSelected] = useState(undefined)
  const options = [
    {
      code: 'personal',
      name: 'No'
    },
    {
      code: 'wedding',
      name: 'Yes'
    },
  ]

  const handleOccasionOnChange = (option) => {
    setSelected(option.code)
    setData(prev => ({
      ...prev,
      occasion: occasions.find(occasion => occasion.code.includes(option.code))
    }))

    setPostHogProperties(option.code)
  }

  const setPostHogProperties = (optionCode) => {
    if (optionCode === 'personal') {
      posthog.setPersonPropertiesForFlags({ eligible_for_loco_lead_form_vending: false })
    }

    reloadExperiments()
  }

  return (
    <>
      {options.map((option) => (
        <div
          key={option.code}
          className={[
            'px-8 py-3',
            'border-b border-gray-300',
          ].join(' ')}
        >
          <Radio
            name="wedding_event"
            label={option.name}
            checked={selected === option.code}
            onChange={_ => handleOccasionOnChange(option)}
          />
        </div>
      ))}
      {errors?.occasion && (
        <div className="font-bold px-8 py-3 border-t border-gray-300">
          <LeadError
            message={errors.occasion}
          />
        </div>
      )}
    </>
  )
}